import Vue from 'vue'
import FormslyUIKit from '@/components/UIKit/index'

Vue.use(FormslyUIKit)

export default new FormslyUIKit()

